export default "__VITE_ASSET__D_71_C0r__"